  /**
   * Parse the time to string
   * @param time
   * return YYYY年MM月DD日（曜日）HH24:MI
   */
  export function ParseTime(timestamp) {
    var date = new Date(timestamp); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
    let Y = date.getFullYear();
    let M = date.getMonth() + 1;
    let D = date.getDate();
    let w = week(date.getDay())
    let h = date.getHours();
    let m = getZero(date.getMinutes());
    // let s = getZero(date.getSeconds());
    let str = Y + "年" + M + "月" + D + "日" + "（" + w + "）" + h + ":" + m
    return str
  }
  /**
   * Parse the time to string
   * @param time
   * return YYYY年MM月DD日（曜日）
   */
  export function ParseDate(timestamp) {
    if(timestamp) {
      var date = new Date(timestamp); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
      let Y = date.getFullYear();
      let M = date.getMonth() + 1;
      let D = date.getDate();
      let w = week(date.getDay())
      let str = Y + "年" + M + "月" + D + "日" + "（" + w + "）"
      return str
    }
  }
  export function ParseTimeAll(timestamp) {
    var date = new Date(timestamp); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
    let Y = date.getFullYear();
    let M = getZero(date.getMonth() + 1);
    let D = getZero(date.getDate());
    let h = date.getHours();
    let m = getZero(date.getMinutes());
    let s = getZero(date.getSeconds());
    let str = Y + "-" + M + "-" + D + " " + h + ":" + m +":" +s
    return str
  }

  export function ParseStartDate(timestamp) {
    var date = new Date(timestamp); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
    let Y = date.getFullYear();
    let M = getZero(date.getMonth() + 1);
    let D = getZero(date.getDate());
    let h = date.getHours();
    let m = getZero(date.getMinutes());
    let str = Y + "/" + M + "/" + D + " " + h + ":" + m
    return str
  }
  export function ParseEndDate(timestamp) {
    var date = new Date(timestamp); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
    let Y = date.getFullYear();
    let M = getZero(date.getMonth() + 1);
    let D = getZero(date.getDate());
    let str = Y + "/" + M + "/" + D
    return str
  }
  export function ParseTimeS(timestamp) {
    var date = new Date(Number(timestamp)); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
    let Y = date.getFullYear();
    let M = date.getMonth() + 1;
    let D = date.getDate();
    let w = week(date.getDay())
    let h = date.getHours();
    let m = getZero(date.getMinutes());
    // let s = getZero(date.getSeconds());
    let str = Y + "年" + M + "月" + D + "日" + "  ( " + w + " ) " + h + ":" + m
    return str
  }

  export function ParseHours(timestamp) {
    var date = new Date(Number(timestamp)); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
    let h = date.getHours();
    let m = getZero(date.getMinutes());
    // let s = getZero(date.getSeconds());
    let str = h + ":" + m
    return str
  }
  export function ParseHoursAll(timestamp) {
    var date = new Date(Number(timestamp)); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
    let h = date.getHours();
    let m = getZero(date.getMinutes());
    let s = getZero(date.getSeconds());
    let str = h + ":" + m +":" +s
    return str
  }


  export function ParseWeek(timestamp) {
    var date = new Date(timestamp); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
    let w = week(date.getDay())
    let str = w
    return str
  }

  export function ParseDay(timestamp) {
    var date = new Date(timestamp); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
    let D = date.getDate();
    let str = D
    return str
  }

  function getZero(num) {
    let str = num < 10 ? '0' + num : num
    return str
  }
  export function weeks(day) {
    // "星期日", "星期一", "星期二", "星期三", "星期四", "星期五", "星期六"
    let weeks = new Array("日", "月", "火", "水", "木", "金", "土");
    let week = weeks[day];
    return week
  }
  export function weeksAll(day) {
    // "星期日", "星期一", "星期二", "星期三", "星期四", "星期五", "星期六"
    let weeks = new Array("日曜日", "月曜日", "火曜日", "水曜日", "木曜日", "金曜日", "土曜日");
    let week = weeks[day];
    return week
  }
  function week(day) {
    // "星期日", "星期一", "星期二", "星期三", "星期四", "星期五", "星期六"
    let weeks = new Array("日", "月", "火", "水", "木", "金", "土");
    let week = weeks[day];
    return week
  }
  // 月:星期1
  // 火
  // 水
  // 木
  // 金
  // 土
  // 日	星期日
  export function codeWeek(code) {
    if (code !== '') {
      let weekArray = [{
          code: 0,
          week: "月"
        },
        {
          code: 1,
          week: "火"
        },
        {
          code: 2,
          week: "水"
        },
        {
          code: 3,
          week: "木"
        },
        {
          code: 4,
          week: "金"
        },
        {
          code: 5,
          week: "土"
        }, {
          code: 6,
          week: "日"
        }
      ]
      let week = weekArray.filter((item) => {
        return item.code == code
      })
      return week[0].week
    }
  }

  export function codeOfValue (paramList) {
    let roleName = ""
    for(let role of paramList){
      if("0101" == role){
        roleName = roleName + "システム管理者、"
      }else if("0102" == role) {
        roleName = roleName + "ヘルプデスク責任者（SB）、"
      }else if("0103" == role) {
        roleName = roleName + "ヘルプデスク担当者（SB）、"
      }else if("0201" == role) {
        roleName = roleName + "ビルメンテナンス担当者、"
      }else if("0202" == role) {
        roleName = roleName + "ビル管理人、"
      }else if("0301" == role) {
        roleName = roleName + "オーナー管理者、"
      }else if("0302" == role) {
        roleName = roleName + "ヘルプデスク責任者、"
      }else if("0303" == role) {
        roleName = roleName + "ヘルプデスク担当者、"
      }else if("0401" == role) {
        roleName = roleName + "テナント管理者、"
      }else if("0402" == role) {
        roleName = roleName + "ポイント管理者、"
      }else if("0403" == role) {
        roleName = roleName + "ポイントユーザー、"
      }else if("0404" == role) {
        roleName = roleName + "テナントユーザー、"
      }else if("0501" == role) {
        roleName = roleName + "iPadユーザ、"
      }
    }

    roleName = roleName.substring(0, roleName.length - 1)
    return roleName
  }

  export function codeOfTrancType (val) {
    let trancType = null
    switch (val) {
      case "1001":
        trancType = "オーナー発行"
        break;
      case "2001":
        trancType = "オーナー配布"
        break;
      case "2002":
        trancType = "テナント配布"
        break;
      case "3001":
        trancType = "テナント変換"
        break;
      case "4001":
        trancType = "施設予約"
        break;
      case "4002":
        trancType = "自由席予約"
        break;
      case "4003":
        trancType = "指定席予約"
        break;
      case "4004":
        trancType = "個人消費"
        break;
      case "4005":
      trancType = "ポイントQR支払"
        break;
      case "5001":
        trancType = "自動チャージ"
        break;
      case "6001":
        trancType = "ポイント失効"
        break;
    }
    return trancType
  }

  export function getWholeMonth(dateParam) {
    let dateMil = dateParam.setMonth(dateParam.getMonth() - 1)

    var date = new Date(dateMil)
    let Y = date.getFullYear()
    let m = date.getMonth() + 1
    let d = date.getDate()

    let startDate = Y + "/" + m + "/" + d
    return startDate
  }

  export function getWholeDay(dateParam) {
    let dateMil = dateParam.setMonth(dateParam.getDay() + 1)

    var date = new Date(dateMil)
    let Y = date.getFullYear()
    let m = date.getMonth()
    let d = date.getDate()

    let startDate = Y + "/" + m + "/" + d
    return startDate
  }
